import { Outlet } from "react-router";
import AdminHeader from "@pages/wallet-discovery/admin-header/admin-header.tsx";

const AdminLayout = () => {
  return (
    <div className="dark:bg-black text-white h-screen p-4 flex flex-col gap-4">
      <AdminHeader />
      <main className="flex flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
